'use client';

import ChevronIcon from '@/components/ui/ChevronIcon/ChevronIcon';

interface SpecialityDropdownButtonProps {
  /** Currently selected speciality label shown on the trigger. */
  label: string;
  /** True while the speciality filter panel is open (rotates the chevron). */
  open: boolean;
  /** Called when the trigger is clicked to toggle the panel. */
  onClick: () => void;
}

/**
 * Trigger for the speciality filter dropdown inside the search bar.
 *
 * This is a *toggle*, not a CTA/navigation button, so it is intentionally
 * independent from `PrimaryButton` (which renders data-driven Links/anchors
 * with booking/enquiry functionality). It renders a truncated label plus a
 * decorative chevron that rotates 180° while the panel is open, styled to
 * sit in the search bar's glass shell.
 */
const SpecialityDropdownButton: React.FC<SpecialityDropdownButtonProps> = ({
  label,
  open,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className="focus:ring-theme-primary/30 min-w-searchbar-filter-min-width rounded-searchbar xl:h-searchbar-trigger-height xl:w-searchbar-filter-min-width flex w-full cursor-pointer items-center justify-between border border-transparent bg-white/20 px-4 py-2.5 text-sm text-gray-600 focus:ring-1 focus:outline-none sm:w-auto sm:py-2 xl:py-0"
  >
    <span className="truncate">{label}</span>
    <span
      className={`pointer-events-none transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
      aria-hidden="true"
    >
      <ChevronIcon />
    </span>
  </button>
);

export default SpecialityDropdownButton;
